// Pure dollars → cents conversion shared by the currency field controller.
// Extracted so the math is unit-testable without a DOM (see dollars_to_cents.test.mjs).
//
// `dollars` is the raw string/number from the visible input. `taxPercent` is the
// account tax rate; when `inclTax` is true the entered amount is tax-inclusive and
// we back out the excl-tax cents (which is what the server stores).
export function dollarsToCents(
  dollars,
  { inclTax = false, taxPercent = 0, allowNegative = false } = {}
) {
  let value = parseFloat(dollars) || 0
  if (value < 0 && !allowNegative) value = 0

  const taxFactor = 1 + parseFloat(taxPercent) / 100
  return inclTax
    ? Math.round((value * 100) / taxFactor)
    : Math.round(value * 100)
}
